import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const RegenerateKeyConfirmDialog = ({ open, onClose, onConfirm, loading }) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundColor: '#242424', m: 0 } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#242424',
          color: '#FFC107',
          pb: 2,
          gap: 1
        }}
      >
        <WarningIcon sx={{ color: '#FF9800' }} />
        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>Regenerate Provision Key</Typography>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: '#242424', pt: 2, pb: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography sx={{ color: '#fff', fontSize: '14px' }}>
            Are you sure you want to regenerate the provision key?
          </Typography>

          <Typography sx={{ color: '#fff', fontSize: '14px' }}>
            Note: If you regenerate the key, the old key will no longer work.
          </Typography>

          {/* Buttons Row */}
          <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
            <Button
              onClick={onClose}
              variant="outlined"
              fullWidth
              disabled={loading}
              sx={{
                flex: 1,
                borderColor: 'rgba(255, 255, 255, 0.3)',
                color: '#fff',
                borderRadius: '4px',
                py: 1,
                fontSize: '14px',
                textTransform: 'capitalize',
                '&:hover': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                flex: 1,
                backgroundColor: '#FFC107',
                color: '#000',
                borderRadius: '4px',
                py: 1,
                fontSize: '14px',
                fontWeight: 600,
                textTransform: 'capitalize',
                '&:hover': { backgroundColor: '#FFD54F' }
              }}
            >
              {loading ? <CircularProgress size={24} sx={{ color: '#000' }} /> : 'Yes, Regenerate'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RegenerateKeyConfirmDialog;
